module.exports = __webpack_public_path__ + "static/media/pepper2.fe9c601f.png";